import Vue              from "vue";
import ToolTipPopOver   from "@/components/Elements/ToolTipPopover.vue"

/** Facet values that trigger the Toyota mast-type tooltip. */
const mastTypes = ["FS", "F", "V", "FSV", "FV", "M", "QFV"];

/** Facet values that trigger the Toyota engine-type tooltip. */
const engineTypes = ["DHM", "DPR", "HCB", "STM"];

/**
 * PartSearchFacetExtras – Renders supplemental UI alongside certain TMS
 * facets, including:
 *  - "SHOW ALL" / "SHOW COMMON" toggle for the Common_Parts / All_Parts facets.
 *  - Toyota-specific tooltips explaining mast and engine type abbreviations.
 */
export default Vue.extend({
    name: "PartSearchFacetExtras",
    components: {
        ToolTipPopOver
    },
    created() {
        this.showToyotaEnginePopup = this.hasFacetMatch("Engine", engineTypes);
        this.showToyotaMastPopup  = this.hasFacetMatch("Mast", mastTypes);
    },
    computed: {
        /** Label text for the Common / All Parts toggle link. */
        showCommonAllText(): string {
            return this.facetKey === "Common_Parts" ? "SHOW ALL" : "SHOW COMMON";
        }
    },
    props: {
        /** Array of facet key/value objects for this facet group. */
        facet: {
            type: Array,
            default: () => []
        },
        /** The facet group key (e.g. "Engine", "Mast", "Common_Parts"). */
        facetKey: {
            type: String,
            default: ""
        }
    },
    data: () => ({
        showToyotaEnginePopup: false,
        showToyotaMastPopup: false,
        toyotaEnginePopupTitle: "TOYOTA ENGINE",
        toyotaEnginePopupText: `<b>DHM</b> - DUST PROOF HIGH CAPACITY BATTERY MOTOR
                                <br /><b>DPR</b> - DUST PROOF MOTOR
                                <br /><b>HCB</b> - HIGH CAPACITY BATTERY MOTOR
                                <br /><b>STM</b> - STANDARD MOTOR`,
        toyotaMastPopupTitle: "TOYOTA MAST",
        toyotaMastPopupText: `<b>FS</b> - 3 STAGE FULL FREE LIFT
                                <br /><b>F</b> - 2 STAGE FULL FREE LIFT
                                <br /><b>V</b> - 2 STAGE WIDE VIEW
                                <br /><b>FSV</b> - 3 STAGE WIDE VIEW FULL FREE LIFT
                                <br /><b>FV</b> - 2 STAGE WIDE VIEW FULL FREE LIFT
                                <br /><b>M</b> - 2 STAGE STANDARD
                                <br /><b>QFV</b> - 4 STAGE WIDE VIEW FULL FREE LIFT`

    }),
    methods: {
        /**
         * Checks whether any value in the current facet array matches a list
         * of known type codes (used to decide whether to show a tooltip).
         */
        hasFacetMatch(expectedKey: string, knownCodes: string[]): boolean {
            if (this.facetKey !== expectedKey) return false;
            return this.facet.some((item: any) => knownCodes.includes(item.Key));
        },

        /** Emits a facet selection event to the parent. */
        addFacet(key: string, value: string) {
            this.$emit("add-facet", key, value);
        }
    }
});
